// AUTO-GENERATED GraphQL Builder for User
import * as Builders from '../';
export class UserBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  email(){ return this.add('email'); }
  name(){ return this.add('name'); }
  passwordHash(){ return this.add('passwordHash'); }
  status(){ return this.add('status'); }
  hasVerifiedEmail(){ return this.add('hasVerifiedEmail'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  auditLogList(b?:(q:Builders.AuditLogBuilder)=>void){
    if(this.depth>=5||this.v.has('auditLogList'))return this;
    this.v.add('auditLogList');
    const n=new Builders.AuditLogBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`auditLogList { ${inner} }`);
    return this;
  }

  customerList(b?:(q:Builders.CustomerBuilder)=>void){
    if(this.depth>=5||this.v.has('customerList'))return this;
    this.v.add('customerList');
    const n=new Builders.CustomerBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`customerList { ${inner} }`);
    return this;
  }

  notificationList(b?:(q:Builders.NotificationBuilder)=>void){
    if(this.depth>=5||this.v.has('notificationList'))return this;
    this.v.add('notificationList');
    const n=new Builders.NotificationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`notificationList { ${inner} }`);
    return this;
  }

  userRoleList(b?:(q:Builders.UserRoleBuilder)=>void){
    if(this.depth>=5||this.v.has('userRoleList'))return this;
    this.v.add('userRoleList');
    const n=new Builders.UserRoleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`userRoleList { ${inner} }`);
    return this;
  }

  vendorUserList(b?:(q:Builders.VendorUserBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorUserList'))return this;
    this.v.add('vendorUserList');
    const n=new Builders.VendorUserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorUserList { ${inner} }`);
    return this;
  }

  reverseAuditLog(b?:(q:Builders.AuditLogBuilder)=>void){
    const n=new Builders.AuditLogBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`auditLogList { ${inner} }`);
    return this;
  }

  reverseCustomer(b?:(q:Builders.CustomerBuilder)=>void){
    const n=new Builders.CustomerBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`customerList { ${inner} }`);
    return this;
  }

  reverseNotification(b?:(q:Builders.NotificationBuilder)=>void){
    const n=new Builders.NotificationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`notificationList { ${inner} }`);
    return this;
  }

  reverseUserRole(b?:(q:Builders.UserRoleBuilder)=>void){
    const n=new Builders.UserRoleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`userRoleList { ${inner} }`);
    return this;
  }

  reverseVendorUser(b?:(q:Builders.VendorUserBuilder)=>void){
    const n=new Builders.VendorUserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorUserList { ${inner} }`);
    return this;
  }
}
